import { useEffect, useState } from 'react';

/** ⌘K / Ctrl+K abre a paleta com a navegação e as ações extras da tela. */
export function usePaletaComandos(): [boolean, (aberta: boolean) => void] {
  const [aberta, setAberta] = useState(false);
  useEffect(() => {
    const aoTeclar = (evento: KeyboardEvent) => {
      if (evento.key.toLowerCase() === 'k' && (evento.metaKey || evento.ctrlKey)) {
        evento.preventDefault();
        setAberta((atual) => !atual);
      }
    };
    window.addEventListener('keydown', aoTeclar);
    return () => {
      window.removeEventListener('keydown', aoTeclar);
    };
  }, []);
  return [aberta, setAberta];
}
